import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom"; // Assuming you're using React Router for routing
import metafile from "../../../assets/images/metafile.png";
import video_icon from "../../../assets/images/video-icon.png";
import deleteicon from "../../../assets/svg//Assetmanagemant/delete_forever.svg";
import locatefile from "../../../assets/svg/Assetmanagemant/locateFile.svg";
import option from "../../../assets/svg/Assetmanagemant/optionIcon.svg";
import icroundsearch from "../../../assets/svg/Assetmanagemant/search.svg";
import uploadicon from "../../../assets/svg/Assetmanagemant/uploadFile.svg";
import "./CmsChannelDetail.scss";
import FileLocationPopup from "./FileLocationPopup";
// import option from "../../../assets/images/option.png";
import axios from "axios";
import { toJS } from "mobx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Asset_Delete,
  Asset_search,
  DeleteallPoster,
  DownloadMetafile,
  FillerList,
  Filler_delete,
  GetPocketFilms,
  MetafileList_By_Partner,
  Metafile_delete,
  ProgramsList_By_Partner,
  Promo_delete,
  PromosList_By_Partner,
} from "../../../api/api";
import { getInstantData, postInstantData } from "../../../api/apiMethod";
import refresh from "../../../assets/images/refresh.png";
import DownloadIcon from "../../../assets/svg/Assetmanagemant/download.svg";
import ImageBlock from "../../../component/Common/ImageBlock";
import NoData from "../../../component/Common/NoData";
import Upload from "../../../component/Common/Upload";
import VideoThumbnail from "../../../component/Common/VideoThumbnail";
import Partitioncontent from "../../../component/content-update/Partitioncontent";
import UploadPosters from "../../../component/content-update/uploadposter";
import Loader from "../../../component/Loader/Loader";
import MetaDataView from "../../../component/metaData/MetaDataView";
import Videoplayer from "../../../component/player-block/Videoplayer";
import VideoPlayerPktFlm from "../../../component/player-block/VideoPlayerPktFlm";
import ErrorPopup from "../../../component/popup/ErrorPopup";
import SearchBar from "../../../component/search-bar/searchBar";
import VideoBlock from "../../../component/Common/VideoBlock";
import appStore from "../../../Config/Store/appStore";
import {
  CMS_Multipart_Complete_URL,
  CMS_Multipart_Fillers,
  CMS_Multipart_PROMOS,
  CMS_Multipart_upload,
  CMS_Multipart_upload_URL,
  Metaupdate_url,
} from "../../../service/API_URL";
import instance from "../../../service/axiosConfig";
import {
  capitalizeFirstLetter,
  isLogin,
  posterimage,
} from "../../../service/commonFunc";
import { permissionDetails } from "../../../utility/localStoageData";
import SearchData from "./SearchData";

function CmsChannelDetail() {
  const navigate = useNavigate();
  const intervalRef = useRef(null);
  // const someValue = useSelector(state => state);
  const assetData = JSON.parse(localStorage.getItem("AssetDetail"));
  const AssetPartnerDetail = useMemo(
    () => JSON.parse(localStorage.getItem("AssetPartnerDetail")),
    []
  );
  const [selectedPosterData, setSelectedPosterData] = useState(null);
  const assetCode = JSON.parse(localStorage.getItem("tenantInfo"));
  const categoryTabs = ["VIDEO", "POSTERS", "TRAILER", "METAFILE"];
  const tabs = ["PROGRAM", "PROMO", "FILLER"];
  const trailerSubtabs = [
    "TEASERS",
    "SONGS",
    "BEHIND THE SCENES",
    "PROMOTIONS",
  ];
  const PART_SIZE = 50 * 1024 * 1024; // 50 MB in bytes
  const [contentArray, setContentArray] = useState(assetData.content);
  const [activeTab, setActiveTab] = useState("PROGRAM");
  const [categoryTab, setCategoryTab] = useState("VIDEO");
  const [partition, setpartition] = useState(false);
  const [posterpartion, setposterpartion] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadFile, setUploadFile] = useState([]);
  const uploadFileRef = useRef(uploadFile);
  const [newUpload, setNewUpload] = useState(null);
  const [uploadurl, setuploadURL] = useState(CMS_Multipart_upload);
  const [filler, setfiller] = useState([]);
  const [promos, setPromos] = useState([]);
  const [Metafile, setMetafile] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [errorbox, setErrorbox] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [btntext, setbtntext] = useState(null);
  const [eventdelete, seteventdelete] = useState(null);
  const [showplayer, setshowplayer] = useState(false);
  const [showHlsplayer, setShowHlsplayer] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [token, setToken] = useState(null);
  const [tokenPath, setTokenPath] = useState(null);
  const [expires, setExpires] = useState(null);
  const [permission, setpermission] = useState(null);
  const [isContentLoading, setIsContentLoading] = useState(false);
  const [isLocateItem, setIsLocateItem] = useState(false);

  const {
    appThemeReducer: { appTheme },
  } = useSelector((state) => state);

  const handleRetryUpload = (selectedFile) => {
    setTimeout(() => {
      if (selectedFile) {
        // Set overrideExisting flag to true

        // Retry the upload with the selected file
        handleFileChange({ target: { files: [selectedFile] } }, true); // Pass true directly
      }
    }, 1000);

    errorboxclose();
  };
  const VideoRetryUpload = () => {
    setTimeout(() => {
      if (selectedFile) {
        // Set overrideExisting flag to true

        // Retry the upload with the selected file
        handleMultipartFileChange({ target: { files: [selectedFile] } }, true); // Pass true directly
      }
    }, 1000);

    errorboxclose();
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  // Api call every 30s if an item is uploaded using locate

  useEffect(() => {
    if (isLocateItem) {
      const currentPartnerId = AssetPartnerDetail?.id;
      intervalRef.current = setInterval(() => {
        assetdetail({ id: currentPartnerId });

        // toast.success("Updated successfully", {
        //   position: toast.POSITION.BOTTOM_RIGHT,
        //   autoClose: 5000,
        // });
      }, 30000);
    } else if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isLocateItem]);

  useEffect(() => {
    if (newUpload != null) {
      (async () => {
        try {
          let response = {};
          const formdata = new FormData();
          formdata.append("filename", newUpload?.fileName);
          if (activeTab === "PROGRAM") {
            let params = newUpload?.params;
            response = await postInstantData(newUpload.URL, formdata, {
              params,
            });
          } else if (activeTab === "FILLER") {
            let params = newUpload?.params;
            response = await postInstantData(newUpload.URL, formdata, {
              params,
            });
          } else if (activeTab === "PROMO") {
            let params = newUpload?.params;
            response = await postInstantData(newUpload.URL, formdata, {
              params,
            });
          }

          const { uploadId, objectKey } = response.data.data;
          const preSignedUrls = await getPreSignedUrls(
            uploadId,
            objectKey,
            newUpload.numberOfParts
          );
          await uploadPart(
            preSignedUrls,
            newUpload.parts,
            uploadId,
            objectKey,
            newUpload.fileName
          );
        } catch (error) {
          let errorMessage = "Something went wrong, please try again later.";
          if (error.response?.status === 400) {
            if (
              error.response.data.message.includes("filename=[") ||
              error.response.data.message.includes("sourcePath=[")
            ) {
              errorMessage =
                "This file already exists. Do you want to override it?";
              setErrorbox(true);
              setbtntext("Override");
              seteventdelete(() => () => VideoRetryUpload());
            } else if (error.response.data.message.includes("duration")) {
              errorMessage =
                "The uploaded file is missing duration metadata. Please upload a valid video file.";
            } else if (
              error.response.data.message.includes("Invalid filename")
            ) {
              errorMessage =
                "The filename is invalid. Please use a valid file name.";
              setbtntext(null);
            }
          }
          setErrorMessage(errorMessage);
          setErrorbox(true); // Show ErrorPopup with the specific message
          setUploadFile([]); // Clear the upload queue
        }
      })();
    }
  }, [newUpload]);
  const splitFormData = (formData, partSize) => {
    const totalSize = formData.size; // Get the total file size in bytes
    const numberOfParts = Math.ceil(totalSize / partSize);

    const parts = [];

    let start = 0;
    let end = partSize;

    for (let i = 0; i < numberOfParts; i++) {
      if (i === numberOfParts - 1) {
        end = totalSize; // Last part might be smaller
      }

      // Create a new Blob for each part
      const partBlob = formData.slice(start, end);
      parts.push(partBlob);

      start = end;
      end += partSize;
    }

    return parts;
  };
  const uplaodassetposter = async (e, id) => {
    const file = e.target.files[0];

    const params = {
      assetId: id,
      partnerId: AssetPartnerDetail?.id,
      promoType: "PROGRAM_PROMO",
      fileSize: file.size,
    };
    // Condition to use either params1 or params2

    const URL = CMS_Multipart_PROMOS;
    const totalSize = file.size;
    const numberOfParts = Math.ceil(totalSize / PART_SIZE);
    const parts = splitFormData(file, PART_SIZE);
    const newUpload = {
      newUpload: {
        name: file.name,
        percentage: 0,
        totalSize,
      },
    };
    setSelectedFile(file);
    setUploadFile([...uploadFile, newUpload]);
    const fileName = file?.name;
    setNewUpload({
      URL,
      numberOfParts,
      params,
      parts,
      fileName,
    });
    setCategoryTab("VIDEO");
    setActiveTab("PROMO");
  };

  const handleMultipartFileChange = async (e, overrider) => {
    setActiveTab(activeTab);
    const file = e.target.files[0];
    const programs = {
      partnerId: AssetPartnerDetail?.id,
      assetType: categoryTab,
      videoType: categoryTab === "VIDEO" ? activeTab : null,
      metadataType: "MOVIES",
      overrideExisting: overrider,

      fileSize: file?.size,
    };

    // Second set of parameters
    const fillers = {
      partnerId: AssetPartnerDetail?.id,
      assetType: categoryTab,
      videoType: categoryTab === "VIDEO" ? activeTab : null,
      metadataType: "MOVIES",
      fillerType: "PARTNER_FILLER",
      overrideExisting: overrider,

      fileSize: file?.size,
    };
    const promo = {
      partnerId: AssetPartnerDetail?.id,
      assetType: categoryTab,
      videoType: categoryTab === "VIDEO" ? activeTab : null,
      metadataType: "MOVIES",
      promoType: "PARTNER_PROMO",
      overrideExisting: overrider,

      fileSize: file.size,
    };
    const assetpromo = {
      assetId: AssetPartnerDetail?.id,
      assetType: categoryTab,
      videoType: categoryTab === "VIDEO" ? activeTab : null,
      metadataType: "MOVIES",
      promoType: "PROGRAM_PROMO",
      overrideExisting: overrider,
      fileSize: file?.size,
    };
    // Condition to use either params1 or params2
    let params;
    if (activeTab === "PROGRAM") {
      params = programs;
    } else if (activeTab === "FILLER") {
      params = fillers;
    } else if (activeTab === "PROMO") {
      params = promo;
    }

    const URL = uploadurl;
    const totalSize = file.size;
    const numberOfParts = Math.ceil(totalSize / PART_SIZE);
    const parts = splitFormData(file, PART_SIZE);
    const newUpload = {
      newUpload: {
        name: file.name,
        percentage: 0,
        totalSize,
      },
    };
    setSelectedFile(file);
    setUploadFile([newUpload]);
    const fileName = file?.name;
    setNewUpload({
      URL,
      numberOfParts,
      params,
      parts,
      fileName,
    });
  };

  const getPreSignedUrls = async (uploadId, objectKey, numberOfParts) => {
    const URL = encodeURI(
      `${CMS_Multipart_upload_URL}?uploadId=${uploadId}&objectKey=${objectKey}&numberOfParts=${numberOfParts}`
    );
    try {
      const response = await getInstantData(URL);
      return response.data;
    } catch (error) {}
  };

  const uploadPart = async (
    preSignedUrls,
    parts,
    uploadId,
    objectKey,
    name
  ) => {
    let uploadCount = 0;

    const uploadPromises = preSignedUrls.map(async (preSignedUrl, i) => {
      const url = preSignedUrl.url;

      try {
        const resp = await axios.put(url, parts[i], {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            // Fix: Ensure progressEvent.total is not zero or undefined
            if (progressEvent.total && progressEvent.total > 0) {
              parts[i].progress =
                (progressEvent.loaded / progressEvent.total) * 100;
            } else {
              parts[i].progress = 0;
            }
            // Only sum up valid progress numbers
            const validProgress = parts.map((p) =>
              typeof p.progress === "number" && !isNaN(p.progress)
                ? p.progress
                : 0
            );
            const overallProgress =
              validProgress.reduce((acc, current) => acc + current, 0) /
              parts.length;

            const newUploadFile = uploadFileRef.current.map((d) => {
              if (d.newUpload.name === name) {
                d.newUpload.percentage = Math.round(overallProgress);
              }
              return d;
            });
            setUploadFile([...newUploadFile]);
          },
        });
        uploadCount += 1;
        const totalProgress = Math.round(
          (100 * uploadCount) / preSignedUrls.length
        );
        let uploadLength = uploadFile.length;
        for (let i = 0; i < uploadLength; i++) {
          if (uploadFile[i].newUpload.name === name) {
            uploadFile[i].newUpload.percentage = totalProgress;
            break;
          }
        }
        return { partNumber: i + 1, eTag: resp.headers["etag"] };
      } catch (error) {
        console.error("Error uploading part", i, error);
        return { partNumber: i + 1, eTag: null };
      }
    });
    const eTags = await Promise.all(uploadPromises);

    completeMultipartUpload(uploadId, objectKey, eTags, name);
  };

  useEffect(() => {
    uploadFileRef.current = uploadFile;
  }, [uploadFile]);

  const completeMultipartUpload = async (
    uploadId,
    objectKey,
    partETags,
    name
  ) => {
    try {
      const response = await instance.post(CMS_Multipart_Complete_URL, {
        uploadId,
        objectKey,
        partETags,
        videoType: activeTab,
      });
      // const newUploadFile = uploadFileRef.filter((d) => d.newUpload.name !== name);
      // if(uploadFile.length == 1) {
      //   setUploadFile([])
      // } else {
      //   setUploadFile(newUploadFile);
      // }
      setTimeout(() => {
        assetdetail(AssetPartnerDetail);
        const newUploadFile = uploadFileRef.current.filter(
          (d) => d.newUpload.name !== name
        );
        setUploadFile(newUploadFile);
      }, 1000);

      toast.success(
        capitalizeFirstLetter(categoryTab) + " uploaded successfully",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        }
      );

      return response.data?.data;
    } catch (error) {
      toast.error("Something went wrong, please try after sometime", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }
  };

  const handleFileChange = async (e, override = false) => {
    const file = e.target.files[0];
    if (!file) {
      toast.error("No file selected.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
      return;
    }

    // Validate file extension
    const fileExtension = file.name
      .slice(file.name.lastIndexOf("."))
      .toLowerCase();
    if (categoryTab === "METAFILE" && fileExtension !== ".xlsx") {
      toast.error(
        "Please upload an .xlsx file. Download the latest .xlsx template from the Metafile tab.",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        }
      );
      return;
    }

    const params = {
      partnerId: AssetPartnerDetail?.id,
      assetType: categoryTab,
      videoType: categoryTab === "VIDEO" ? activeTab : null,
      metadataType: "MOVIES",
      overrideExisting: override,
      name: file.name,
      fileSize: file.size,
    };

    const URL =
      categoryTab === "METAFILE" ? Metaupdate_url : CMS_Multipart_upload;
    const formData = new FormData();
    formData.append("file", file);
    const uploadFilename = {
      name: file.name,
      percentage: 0,
    };
    setUploadFile([...uploadFile, uploadFilename]);
    setSelectedFile(file);

    try {
      const response = await instance.post(URL, formData, { params });
      toast.success(
        `${capitalizeFirstLetter(categoryTab)} uploaded successfully`,
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        }
      );
      setUploadFile(uploadFile.filter((e) => e.name !== file.name));
      assetdetail(AssetPartnerDetail);
    } catch (error) {
      let errorMessage = "Something went wrong, please try again later.";
      if (error.response?.status === 400) {
        if (
          error.response.data.message.includes("filename=[") ||
          error.response.data.message.includes("sourcePath=[")
        ) {
          errorMessage =
            "This file already exists. Do you want to override it?";
          setbtntext("Override");
          seteventdelete(() => () => handleRetryUpload(file));
          setErrorbox(true);
        } else {
          errorMessage =
            error.response.data.message ||
            "Invalid file. Please check the file and try again.";
          setErrorbox(true);
        }
      }
      setErrorMessage(errorMessage);
      toast.error(errorMessage, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }
  };
  const getPermission = () => {
    let findEdit = permissionDetails();
    if (findEdit.includes("ASSET_MANAGEMENT_EDIT")) setpermission("edit");
    else if (findEdit.includes("ASSET_MANAGEMENT_READ")) setpermission("read");
    else setpermission(null);
  };

  useEffect(() => {
    getPermission();
    isLogin();

    assetdetail(AssetPartnerDetail); // Call the fetchData function
  }, []);

  const programVideos = contentArray;
  const promosVideos = promos;
  const SecondaryData = contentArray.filter(
    (item) => item.assetType === "SECONDARY"
  );
  const partnerId = AssetPartnerDetail?.id;
  const hasAnyLocateCopyStatus = useMemo(() => {
    const programHas = Array.isArray(programVideos)
      ? programVideos.some((item) => item?.copyStatus === "IN_PROGRESS")
      : false;
    const promosHas = Array.isArray(promosVideos)
      ? promosVideos.some((item) => item?.copyStatus === "IN_PROGRESS")
      : false;
    const fillerHas = Array.isArray(filler)
      ? filler.some((item) => item?.copyStatus === "IN_PROGRESS")
      : false;
    return programHas || promosHas || fillerHas;
  }, [programVideos, promosVideos, filler]);

  useEffect(() => {
    setIsLocateItem(hasAnyLocateCopyStatus);
  }, [hasAnyLocateCopyStatus]);
  const MetafileData = Metafile;

  const [programVid, setprogramVid] = useState(programVideos);

  const handlecategoryTab = (tab) => {
    setpartition(false);
    setposterpartion(false);
    setCategoryTab(tab);
    if (tab === "VIDEO") {
      handleTabClick("PROGRAM");
    }
    if (tab === "TRAILER") {
      setActiveTab("TEASERS");
    }
    if (tab === "POSTERS") {
      setposterpartion(true);
    }
    // else {
    //   setposterpartion(false);
    // }
    appStore.setAssetSignledata(null);
    setSelectedPosterData(null);
  };

  const handleTabClick = (tab) => {
    setpartition(false);
    setposterpartion(false);
    setActiveTab(tab);
    if (tab === "PROGRAM") {
      setprogramVid(programVideos);
      setuploadURL(CMS_Multipart_upload);
    } else if (tab === "FILLER") {
      setprogramVid(filler);
      setuploadURL(CMS_Multipart_Fillers);
    } else if (tab === "PROMO") {
      setuploadURL(CMS_Multipart_PROMOS);
      setprogramVid(promosVideos);
    }
  };

  const opendata = (data, bool, e) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }

    setposterpartion(false);
    setpartition(true);
    const plainData = toJS(data);
    appStore.setAssetSignledata(plainData);
  };
  useEffect(() => {
    console.log("partition", partition, posterpartion);
  }, [partition, posterpartion]);
  const onUploadPosterClick = (data, e) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }

    setpartition(false);
    setposterpartion(true);
    const plainData = toJS(data);
    appStore.setAssetSignledata(plainData);
    setSelectedPosterData(plainData);
  };

  const assetDeleteConfirm = (assetid, e) => {
    e.stopPropagation();
    deletepopup(e, assetid, "asset");
  };
  const assetdelete = async (assetid, e) => {
    e.stopPropagation();
    setpartition(false);
    setposterpartion(false);
    const deleteasset = await Asset_Delete(assetid);

    if (deleteasset === true) {
      assetdetail(AssetPartnerDetail);
      toast.success("Video deleted successfully", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    } else {
      toast.error("Something went wrong, please try after sometime", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }
  };
  const fillerDeleteConfirm = (assetid, e) => {
    deletepopup(e, assetid, "fillerdelete");
  };
  const fillerdelete = async (assetid) => {
    setpartition(false);
    setposterpartion(false);
    const deleteasset = await Filler_delete(assetid);
    if (deleteasset.status === 200) {
      assetdetail(AssetPartnerDetail);
      toast.success("Filler deleted successfully", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    } else {
      toast.error("Something went wrong, please try after sometime", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }
  };
  const promoDeleteConfirm = (assetid, e) => {
    deletepopup(e, assetid, "promodelete");
  };
  const promodelete = async (assetid) => {
    setpartition(false);
    setposterpartion(false);
    const deleteasset = await Promo_delete(assetid);

    if (deleteasset.status === 200) {
      assetdetail(AssetPartnerDetail);
      toast.success("Promo deleted successfully", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    } else {
      toast.error("Something went wrong, please try after sometime", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }
  };
  const assetdetail = async (AssetPartnerDetail) => {
    if (!partition) {
      setIsContentLoading(true);
    } // Start loader
    const params = {
      partnerId: AssetPartnerDetail?.id,
    };
    const partid = {
      partnerId: AssetPartnerDetail?.id,
      pageSize: "1000",
    };

    const AssetDetail = await ProgramsList_By_Partner(partid);
    const Fillerlisting = await FillerList(partid);
    const Promolisting = await PromosList_By_Partner(partid);
    const MetaDatalisting = await MetafileList_By_Partner(params);

    if (AssetDetail.status === true) {
      localStorage.setItem("AssetDetail", JSON.stringify(AssetDetail?.data));

      setContentArray(JSON.parse(localStorage.getItem("AssetDetail"))?.content);
    }
    if (Fillerlisting?.status === true) {
      setfiller(Fillerlisting?.data.content);
    }
    if (Promolisting?.status === true) {
      setPromos(Promolisting?.data.content);
    }
    if (MetaDatalisting?.status === true) {
      setMetafile(MetaDatalisting?.data);
    }
    // dispatch(AssetDetailAction(AssetDetail?.data))
    if (toJS(appStore.assetSignledata) != null) {
      const filteredItems = AssetDetail?.data?.content.filter(
        (item) => item.id === toJS(appStore.assetSignledata)?.id
      );

      appStore.setAssetSignledata(toJS(filteredItems[0]));
    }
    // setFilteredData(filteredItems);
    if (!partition) {
      setIsContentLoading(false);
    } // Stop loader after all content is set
  };

  const bulkEdit = () => {
    navigate("/meta-edit", {
      state: {
        id: AssetPartnerDetail.id,
        name: AssetPartnerDetail.name,
      },
    });
  };

  const metaEditView = () => {
    navigate("/meta-edit");
  };

  const deleteallposter = async (event, id) => {
    errorboxclose();
    // event.stopPropagation();
    const response = await DeleteallPoster(id);
    if (response.data.status === true) {
      setTimeout(() => {
        assetdetail(AssetPartnerDetail);
      }, 1000);

      toast.success("Posters deleted successfully", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    } else {
      toast.error(
        response.data.message
          ? response.data.message
          : "Something went wrong, please try after sometime",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        }
      );
    }
  };

  const databymeta = (data) => {
    appStore.setAssetSignledata(toJS(data));
  };
  const [expandMeta, setExpandMeta] = useState(true);
  const [ismetadata, setIsmetadata] = useState(true);
  const expandMetaView = () => {
    setExpandMeta(false);
    setIsmetadata(true);
  };

  const minmizemeta = () => {
    setExpandMeta(true);
    assetdetail(AssetPartnerDetail);
  };
  const [searchQuery, setSearchQuery] = useState("");
  const [searchData, setSearchData] = useState(null);
  const handleKeyPress = (e) => {
    // if (e.key === "Enter") {
    //   AssetSearch(searchQuery);
    // }
    if (e.length >= 3 || e.length < 1) {
      AssetSearch(e);
    }
  };
  const AssetSearch = async (searchQuery) => {
    const data = {
      id: AssetPartnerDetail?.id,
      query: searchQuery,
    };
    setSearchQuery(data.query);
    const partnerDataSearch = await Asset_search(data);

    setSearchData(partnerDataSearch.data);

    setExpandMeta(false);
    // setIsmetadata(true);
    setIsmetadata(false);
  };

  const errorboxclose = () => {
    setUploadFile([]);
    assetdetail(AssetPartnerDetail);
    setErrorMessage("");
    setErrorbox(false);
  };
  // const [errorbox, setErrorbox] = useState(false);
  // const [errorMssage, setErrorMssage] = useState("");

  const deleteMetafile = async (event, id) => {
    errorboxclose();
    event.stopPropagation();

    const response = await Metafile_delete(id);

    if (response.data.status === true) {
      setTimeout(() => {
        assetdetail(AssetPartnerDetail);
      }, 1000);
      toast.success("Metafile deleted successfully", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    } else if (response.data.status === false) {
      toast.error(
        response.data.message
          ? response.data.message
          : "Something went wrong, please try after sometime",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        }
      );
    } else {
      toast.error("Something went wrong, please try after sometime", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }
  };
  const deletepopup = (event, id, method = "") => {
    // event.stopPropagation();
    console.log("deletepopup called with:", event, id, method);

    setbtntext("Delete");
    setErrorMessage("Do you want to delete ?");
    setErrorbox(true);
    console.log("errorbox delete", errorbox);
    switch (method) {
      case "asset":
        seteventdelete(() => () => assetdelete(id, event));
        break;
      case "fillerdelete":
        seteventdelete(() => () => fillerdelete(id));
        break;
      case "promodelete":
        seteventdelete(() => () => promodelete(id));
        break;
      default:
        seteventdelete(() => () => deleteallposter(event, id));
    }
  };
  const deletemetafilepopup = (event, id) => {
    event.stopPropagation();
    setbtntext("Delete");
    setErrorMessage("Do you want to delete ?");
    setErrorbox(true);
    seteventdelete(() => () => deleteMetafile(event, id));
  };

  const openplayerdata = (data) => {
    if (assetCode?.code === "pktflm") {
      const url = data?.metadata?.contentPlaybackUrl;
      const videoUrl = url.split("?token=");
      const token = videoUrl[1].split("&token_path=%");
      const tokenPath = token[1].split("&expires=");
      const expires = tokenPath[1];
      function hex_to_ascii(str1) {
        var hex = str1.toString();
        var str = "";
        for (var n = 0; n < hex.length; n += 2) {
          str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
        }
        return str;
      }
      appStore.setAssetSignledata(toJS(data));
      console.log("player data", toJS(appStore.assetSignledata));
      setVideoUrl(videoUrl[0]);
      setToken(token[0]);
      setTokenPath(hex_to_ascii(tokenPath[0]));
      setExpires(expires);
      setShowHlsplayer(true);
    } else {
      if (data?.isPlaceHolder && activeTab === "PROGRAM") {
        appStore.setAssetSignledata(toJS(data));
        setshowplayer(true);
      } else {
        appStore.setAssetSignledata(toJS(data));
        setshowplayer(true);
      }
    }
  };

  const closeplayer = () => {
    setShowHlsplayer(false);
    setshowplayer(false);
  };

  const syncPocketFilms = async () => {
    const res = await GetPocketFilms(AssetPartnerDetail?.id);
    if (res?.status === 200) {
      toast.success("Sync Completed", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
      handleTabClick("PROGRAM");
    } else {
      toast.error("Something went wrong, please try after sometime", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }
  };

  const downloadMetafile = async (event, id, filename) => {
    event.preventDefault();
    event.stopPropagation();
    // toast.info("Downloading metafile...", { position: "bottom-right" });
    try {
      const response = await DownloadMetafile(
        AssetPartnerDetail?.id || 1,
        filename,
        assetCode?.code || "example"
      );
      toast[response.success ? "success" : "error"](response.message, {
        position: "bottom-right",
        autoClose: 5000,
      });
    } catch (error) {
      console.error("Error calling DownloadMetafile:", error);
      toast.error("Failed to download metafile. Please try again.", {
        position: "bottom-right",
        autoClose: 5000,
      });
    }
  };
  console.log(" expandMeta  ", expandMeta);
  return permission !== null ? (
    <div className={`content-body channel-detail ${appTheme}`}>
      {showplayer ? (
        <Videoplayer
          closepartition={() => closeplayer()}
          programVideos={programVid}
          videodata={toJS(appStore.assetSignledata)}
          searchQuerys={searchQuery}
        />
      ) : showHlsplayer ? (
        <VideoPlayerPktFlm
          closepartition={() => closeplayer()}
          videodata={toJS(appStore.assetSignledata)}
          programVideos={programVid}
          src={videoUrl}
          token={token}
          tokenPath={tokenPath}
          expires={expires}
          databymeta={openplayerdata}
        />
      ) : expandMeta ? (
        <div className="dashboard-content">
          <div className="top-content">
            <div className="left-side">
              <div className="breadcrumbs">
                <ul>
                  <li>
                    <Link to="/asset">Asset Management</Link>
                  </li>
                  <li className="active">{AssetPartnerDetail?.name}</li>
                </ul>
              </div>
            </div>
            <div className="right-side">
              <div className="icon-list">
                <SearchBar
                  searchQuery={searchQuery}
                  placeholder="Search using Filename..."
                  searchOutput={handleKeyPress}
                  keyEnter={false}
                  appTheme={appTheme}
                  icon={icroundsearch}
                />
              </div>
            </div>
          </div>

          <div className="channel-category">
            <ul className="channel-category-tab">
              {categoryTabs.map((tab) => {
                return (
                  <li
                    className={`${categoryTab === tab ? "active" : ""}`}
                    onClick={() => handlecategoryTab(tab)}
                  >
                    {tab}
                  </li>
                );
              })}
            </ul>
            <div className="action-buttons">
              <div className="bulk-edit">
                <button
                  onClick={bulkEdit}
                  className="default-odd border-0 btn-light-red-ml-auto mr-0"
                >
                  Meta Edit
                </button>
              </div>

              <Link
                to="/channel-actions"
                className="default-odd border-0 btn-light-red-ml-auto mr-0"
              >
                Actions
              </Link>
            </div>
          </div>
          <div className="row  mt-2 ">
            <div
              className={
                partition || posterpartion ? "col-8 partitionOn" : "col-12"
              }
            >
              {categoryTab === "VIDEO" && (
                <div className="channel-content">
                  <div className="channel-top">
                    <div className="left-side">
                      <ul className="tabs">
                        {tabs.map((tab) => {
                          return (
                            <li
                              className={`tab-a ${
                                activeTab === tab ? "active" : ""
                              }`}
                              onClick={() => handleTabClick(tab)}
                            >
                              {tab}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                    {permission === "edit" ? (
                      <div className="right-side browse-btns">
                        {assetCode?.code === "pktflm" ||
                        assetCode?.code === "nhstdz" ? (
                          <>
                            {assetCode?.code === "pktflm" ? (
                              <a
                                className="mx-2"
                                onClick={() => syncPocketFilms(true)}
                              >
                                <img
                                  src={refresh}
                                  height={25}
                                  width={25}
                                  alt=""
                                />
                              </a>
                            ) : (
                              ""
                            )}
                            <input
                              type="file"
                              id="fileInput"
                              style={{ display: "none" }}
                              accept=".mp4,.mov"
                              multiple
                              onChange={(e) =>
                                handleMultipartFileChange(e, false)
                              }
                            />
                            <button
                              className="locateButton"
                              onClick={() =>
                                document.getElementById("fileInput").click()
                              }
                            >
                              <img src={uploadicon} alt="upload" />
                            </button>
                          </>
                        ) : (
                          <>
                            <input
                              type="file"
                              id="fileInput"
                              style={{ display: "none" }}
                              accept=".mp4,.mov"
                              multiple
                              onChange={(e) =>
                                handleMultipartFileChange(e, false)
                              }
                            />
                            <button
                              className="locateButton"
                              onClick={() => setShowPopup(true)}
                            >
                              <img src={locatefile} alt="locatefile" />
                            </button>
                            <button
                              className="locateButton"
                              onClick={() =>
                                document.getElementById("fileInput").click()
                              }
                            >
                              <img src={uploadicon} alt="upload" />
                            </button>
                          </>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {isContentLoading ? (
                    <div
                      style={{
                        background: "rgb(18, 18, 18, 0.6)",
                        height: "50vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                        borderRadius: "8px",
                      }}
                    >
                      <Loader />
                    </div>
                  ) : (
                    <>
                      {/* All Video contents  */}
                      <div className="content-wrapper">
                        <div
                          id="tab-1"
                          className={`tab-content ${
                            activeTab === "PROGRAM" ? "active" : ""
                          }`}
                        >
                          <div className="video-channel-list part-heights">
                            {uploadFile?.length > 0 &&
                              uploadFile.map((data) => (
                                <Upload data={data} key={data.name} />
                              ))}
                            {programVideos.length !== 0 ? (
                              programVideos.map((data) => {
                                let image = posterimage(data);
                                return (
                                  <VideoBlock
                                    assetSignledata={appStore.assetSignledata}
                                    key={data.id} // Add a unique key
                                    data={data}
                                    onVideoClick={opendata}
                                    onUploadPosterClick={(e) =>
                                      onUploadPosterClick(data, e)
                                    }
                                    onDeleteClick={assetDeleteConfirm}
                                    // onArchiveClick={onArchiveClick}
                                    onUploadPromos={(e) => {
                                      uplaodassetposter(e, data.id);
                                    }}
                                    image_url={image}
                                    openplayercomp={openplayerdata}
                                    permission={permission}
                                    partitionOn={partition}
                                  />
                                );
                              })
                            ) : (
                              <>
                                <NoData />{" "}
                              </>
                            )}
                          </div>
                        </div>

                        <div
                          id="tab-2"
                          className={`tab-content ${
                            activeTab === "PROMO" ? "active" : ""
                          }`}
                        >
                          <div className="video-channel-list part-heights">
                            {uploadFile?.length > 0 &&
                              uploadFile.map((data) => {
                                return <Upload data={data} key={data.name} />;
                              })}
                            {promosVideos.length !== 0 ? (
                              promosVideos.map((data, index) => {
                                return (
                                  <VideoThumbnail
                                    data={data}
                                    openplayerdata={openplayerdata}
                                    index={index}
                                    deleteFunction={(e) =>
                                      promoDeleteConfirm(data.id, e)
                                    }
                                    permission={permission}
                                  />
                                );
                              })
                            ) : (
                              <>
                                <NoData />{" "}
                              </>
                            )}
                          </div>
                        </div>
                        <div
                          id="tab-3"
                          className={`tab-content ${
                            activeTab === "FILLER" ? "active" : ""
                          }`}
                        >
                          <div className="video-channel-list part-heights">
                            {uploadFile?.length > 0 &&
                              uploadFile.map((data) => (
                                <Upload data={data} key={data.name} />
                              ))}
                            {filler.length !== 0 ? (
                              filler?.map((data, index) => {
                                return (
                                  <VideoThumbnail
                                    data={data}
                                    openplayerdata={openplayerdata}
                                    index={index}
                                    deleteFunction={(e) =>
                                      fillerDeleteConfirm(e)
                                    }
                                    permission={permission}
                                  />
                                );
                              })
                            ) : (
                              <>
                                <NoData />{" "}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              )}
              {categoryTab === "POSTERS" && (
                <div className="channel-content">
                  <div className="channel-top">
                    <div className="left-side"></div>
                    {permission === "edit" ? (
                      <div className="right-side">
                        <input
                          type="file"
                          id="fileInput"
                          style={{ display: "none" }}
                          accept="image/*"
                          onChange={(e) => handleFileChange(e, false)}
                        />
                        <button
                          className="locateButton"
                          onClick={() =>
                            document.getElementById("fileInput").click()
                          }
                        >
                          <img src={uploadicon} alt="upload" />
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="channel-content postercontent">
                    <div className="video-channel-list part-heights">
                      {programVideos.length !== 0 ? (
                        programVideos.map((data, index) => {
                          let image = posterimage(data);
                          return (
                            <ImageBlock
                              image={image}
                              data={data}
                              postertab={onUploadPosterClick}
                              deletepopup={deletepopup}
                              permission={permission}
                              assetSignledata={toJS(appStore.assetSignledata)}
                              index={index}
                            />
                          );
                        })
                      ) : (
                        <>
                          <NoData />{" "}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {categoryTab === "TRAILER" && (
                <div className="channel-content">
                  <div className="channel-top">
                    <div className="left-side">
                      <ul className="tabs">
                        {trailerSubtabs.map((tab) => {
                          return (
                            <li
                              className={`tab-a ${
                                activeTab === tab ? "active" : ""
                              }`}
                              onClick={() => handleTabClick(tab)}
                            >
                              {tab}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                    {permission === "edit" ? (
                      <div className="right-side">
                        <input
                          type="file"
                          id="fileInput"
                          style={{ display: "none" }}
                          accept=".mp4,.mov"
                          multiple
                          onChange={(e) => handleMultipartFileChange(e, false)}
                        />
                        <button
                          className="locateButton"
                          onClick={() =>
                            document.getElementById("fileInput").click()
                          }
                        >
                          <img src={uploadicon} alt="upload" />
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <NoData />
                </div>
              )}
              {categoryTab === "SECONDARY" && (
                <div className="channel-content">
                  <div className="channel-top">
                    <div className="left-side"></div>
                    {permission === "edit" ? (
                      <div className="right-side">
                        <input
                          type="file"
                          id="fileInput"
                          style={{ display: "none" }}
                          onChange={(e) => handleFileChange(e, false)}
                        />
                        <button
                          className="locateButton"
                          onClick={() =>
                            document.getElementById("fileInput").click()
                          }
                        >
                          <img src={uploadicon} alt="upload" />
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="content-wrapper">
                    <div className="video-channel-list part-heights">
                      {SecondaryData &&
                        SecondaryData.map(() => {
                          return (
                            <div
                              style={{
                                border: "1px solid",
                                borderImage:
                                  "linear-gradient(56deg,#FFFFFF29,#FFFFFF14,#FFFFFF29) 1",

                                borderRadius: "6px",
                              }}
                              className="block"
                            >
                              <img src={video_icon} alt="" />
                              <label>Video 1</label>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              )}

              {categoryTab === "METAFILE" && (
                <div className="channel-content">
                  <div className="channel-top">
                    <div className="left-side"></div>
                    {permission === "edit" ? (
                      <div className="right-side">
                        <input
                          type="file"
                          id="fileInput"
                          style={{ display: "none" }}
                          accept=".xlsx"
                          onChange={(e) => handleFileChange(e, false)}
                        />
                        <button
                          className="locateButton"
                          onClick={() =>
                            document.getElementById("fileInput").click()
                          }
                        >
                          <img src={uploadicon} alt="upload" />
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="video-channel-list part-heights">
                    {MetafileData && MetafileData.length > 0 ? (
                      MetafileData.map((data) => (
                        <div
                          style={{
                            background: `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #0F3B47, #36D2FF, #0F3B47) border-box`,
                            borderRadius: "6px",
                            border: "1px solid transparent",
                            padding: "5px",
                            transition: "all 0.3s",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #22BBBE, #7DAD41, #F4B719, #E55824, #B52C80) border-box`;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #0F3B47, #36D2FF, #0F3B47) border-box`;
                          }}
                          className="block"
                          onClick={metaEditView}
                          key={data.id}
                        >
                          <div className="img-block">
                            <img src={metafile} alt="Metafile" />
                          </div>
                          {/* <div className="text-block">
                        <label className="text-label">
                          {data?.metadata?.title || data.filename || "Unnamed File"}
                        </label>
                      </div> */}
                          <div className="text-block">
                            <label
                              className="text-label"
                              title={
                                data?.metadata?.title ||
                                data.filename ||
                                "Unnamed File"
                              }
                            >
                              {data?.metadata?.title ||
                                data.filename ||
                                "Unnamed File"}
                            </label>
                          </div>
                          <div className="dropdown">
                            <a className="dropdown-button">
                              <img src={option} alt="Options" />
                            </a>
                            <div className="dropdownContent metadropdown">
                              <a
                                onClick={(e) =>
                                  downloadMetafile(e, data.id, data.filename)
                                }
                                className="dropDownOptions"
                              >
                                <span className="img-box">
                                  <img src={DownloadIcon} alt="Download" />
                                </span>
                                Download
                              </a>
                              {permission === "edit" && (
                                <a
                                  onClick={(e) =>
                                    deletemetafilepopup(e, data.id)
                                  }
                                  className="dropDownOptions"
                                >
                                  <span className="img-box">
                                    <img src={deleteicon} alt="Delete" />
                                  </span>
                                  Delete
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="nocontent">No metafiles available.</div>
                    )}
                  </div>
                </div>
              )}
            </div>
            {errorbox && (
              <ErrorPopup
                btntext={btntext}
                message={errorMessage}
                closebox={() => errorboxclose()}
                overrides={() => eventdelete()}
              />
            )}
            {partition && (
              <Partitioncontent
                assetdetail={() => assetdetail(AssetPartnerDetail)}
                expandMetaView={() => expandMetaView()}
                videodata={appStore.assetSignledata} // <-- use local state here
                closepartition={() => {
                  setpartition(false);
                }}
              />
            )}

            {posterpartion && (
              <UploadPosters
                videodata={selectedPosterData} // <-- use local state here
                assetdetail={() => assetdetail(AssetPartnerDetail)}
                permission={permission}
              />
            )}
          </div>
        </div>
      ) : ismetadata ? (
        <MetaDataView
          closepartition={() => minmizemeta()}
          videoMetadata={toJS(appStore.assetSignledata)}
          assetdetail={() => assetdetail(AssetPartnerDetail)}
          programVideos={programVideos}
          databymeta={databymeta}
        />
      ) : (
        <SearchData
          videodata={toJS(appStore.assetSignledata)}
          searchdata={searchData}
          AssetSearch={AssetSearch}
          assetdetail={() => assetdetail(AssetPartnerDetail)}
          searchQuerys={searchQuery}
          permission={permission}
          deletepopup={deletepopup}
          fillerDeleteConfirm={fillerDeleteConfirm}
          promoDeleteConfirm={promoDeleteConfirm}
          uplaodassetposter={uplaodassetposter}
        />
      )}
      <ToastContainer />
      <FileLocationPopup
        show={showPopup}
       assetdetail ={ () => assetdetail(AssetPartnerDetail)}
        handleClose={closePopup}
        data={{
          videoType: activeTab,
          partnerID: AssetPartnerDetail.id,
        }}
      />
    </div>
  ) : (
    ""
  );
}

export default CmsChannelDetail;


